export default "__VITE_ASSET__DTvlLhhG__"